import $ from "jquery";

$('.nav-tabs .nav-tabs__link').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $('.nav-tabs .nav-tabs__link').removeClass('nav-tabs__link--active');
    $('.tabs .tabs__pane').removeClass('tabs__pane--active');

    $(this).addClass('nav-tabs__link--active');
    $(tab_id).addClass('tabs__pane--active');
});

$('.tabs .tabs__button-mobile').click(function(e) {
    e.preventDefault();

    $('.tabs .tabs__button-mobile').removeClass('tabs__button-mobile--active');
    $('.tabs .tabs__pane').removeClass('tabs__pane--active');

    $(this).addClass('tabs__button-mobile--active');
    $(this).parent('.tabs__pane').addClass('tabs__pane--active');
});